/** API / UI mode for a time entry (machine vs task vs unspecified). */
export const TIME_MODE_TYPE = {
  MACHINE: 0,
  TASK: 1,
  UNSPECIFIED: 2,
} as const;

export type TimeModeType = (typeof TIME_MODE_TYPE)[keyof typeof TIME_MODE_TYPE];
